import styled from 'styled-components';

import { OVERLAP_SEARCH_AND_SHUFFLE } from '@xing-com/crate-jobs-pages-find-jobs-search-bar';
import { spaceXXL } from '@xing-com/tokens';

export const SearchAndSwipeContainer = styled.section`
  display: flex;
  position: relative;
  margin-top: -${OVERLAP_SEARCH_AND_SHUFFLE};
  margin-bottom: ${spaceXXL};
`;
